<div class="modal-Change-Password">
  <div class="switch-agency modal-dialog modal-dialog-centered" id="dialog">
    <div class="modal-content form-change-password">
      <div class="text-center mb-3">
        <div class="logoLogin">
          <img class="logoIcon" src="../../../assets/icons/Logo.png" alt="Logo icon"/>
        </div>
        <h2 class="HeaderLogin">OPEEKA</h2>
      </div>
      <div class="form-group mt-4">
        <mat-form-field appearance="fill">
          <mat-label>{{'Agency' | translate}}</mat-label>
          <mat-select
            [(ngModel)]="selectedAgency"
            (selectionChange)="setDefault($event,'onchange')"
            disableOptionCentering
            panelClass="switch-agency-panel">
            <mat-select-trigger>{{ getSelectedAgencyName() }}</mat-select-trigger>
            <mat-option class="select-search-option">
              <ngx-mat-select-search noEntriesFoundLabel="{{ 'No results found' | translate }}" hideClearSearchButton="true"
                placeholderLabel="{{ 'Search' | translate }}" [formControl]="agencyFilterCtrl"></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngIf="agencies.length === 0" disabled>
                {{ 'No results found' | translate }}
              </mat-option>
            <mat-option *ngFor="let agency of agencies" [value]="agency.agencyID">
              {{ agency.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    <div class="form-group mt-4 d-flex align-items-center">
      <input
        type="checkbox"
        id="defaultAgency"
        [(ngModel)]="isDefault"
        aria-label="Set as default agency"
        class="me-2"
      />
      <label for="defaultAgency" class="mb-0 ml-2">
        {{ 'Set as default agency' | translate }}
      </label>
    </div>
      <div class="mt-3">
        <button type="submit" class="btn btnTeal pwd-btn" (click)="go()">
          {{'Go' | translate}}
        </button>
      </div>
      <div class="mt-1 text-center">
        <a class="btn-cancel" (click)="hide()">{{'Cancel' | translate}}</a>
      </div>
    </div>
  </div>

</div>
